import { VFC } from "react";

import PartnersPage from "pages/shipper/pages/partners/PartnersPage";
import { useTranslation } from "react-i18next";
import { Route, Switch } from "react-router-dom";
import { withTitle } from "utils/layout/withTitle";

import CarrierIntegrationsPage from "./CarrierIntegrationsPage";
import PartnersPagesTabsContainer from "./containers/PartnersPagesTabsContainer";
import { CARRIER_INTEGRATIONS_PAGE_PATH, PARTNERS_PAGE_PATH } from "./routing";
import { usePartnersSlice } from "./store/partnersStore";

const PartnersPages: VFC = () => {
  usePartnersSlice();
  const { t } = useTranslation(["shipper"]);
  return (
    <>
      <PartnersPagesTabsContainer />
      <Switch>
        <Route
          exact
          path={PARTNERS_PAGE_PATH}
          render={() => withTitle(PartnersPage, { title: t("shipper:partners") })}
        />
        <Route
          exact
          path={CARRIER_INTEGRATIONS_PAGE_PATH}
          render={() => withTitle(CarrierIntegrationsPage, { title: t("shipper:carrierIntegrations") })}
        />
      </Switch>
    </>
  );
};

export default PartnersPages;
